import { TableRoom } from 'src/pages/OfferPage/TableSvgOrganizer/TableRoom';
import { FloorSvgs } from './FloorSvgs';
import { ProjectQuoteUserProperties } from "src/model/api/project.model";
import { GetAllManufacturerDiscountForProjectResponse } from "src/model/api/manufacturer-discount.model";
import { Product } from "src/model/product.model";
import { ManufacturerRecommendationResponse } from "src/model/api/manufacturer-recommendation";

export const TableFloor = (
    {
      projectId,
      tableFloor,
      detailsEnabled,
      tablesEnabled,
      tableDLStarted,
      svgDLStarted,
      wifiEnabled,
      wiringEnabled,
      cameraEnabled,
      floorMapsEnabled,
      roomMapsEnabled,
      lightingEnabled,
      svgs,
      currency,
      dispatchDownloadStates,
      currentRowInEditing,
      setCurrentRowInEditing,
      measurementSystem,
      quoteUserProperties,
      allManufacturerDiscountForProject,
      manufacturerRecommendationForProject,
      customItemsForRecommendation,
    }: {
      projectId: number;
      tableFloor: any;
      detailsEnabled: boolean;
      tablesEnabled: boolean;
      tableDLStarted: boolean;
      svgDLStarted: boolean;
      wifiEnabled: boolean;
      wiringEnabled: boolean;
      cameraEnabled: boolean;
      floorMapsEnabled: boolean;
      roomMapsEnabled: boolean;
      lightingEnabled: boolean;
      svgs: any;
      currency: string;
      dispatchDownloadStates: any;
      currentRowInEditing: any;
      setCurrentRowInEditing: any;
      measurementSystem: string;
      quoteUserProperties: ProjectQuoteUserProperties;
      allManufacturerDiscountForProject: GetAllManufacturerDiscountForProjectResponse;
      manufacturerRecommendationForProject: ManufacturerRecommendationResponse;
      customItemsForRecommendation: Product[];
    }
) => {

  const hasFloorHeader =
    (roomMapsEnabled && (!svgs || (!!svgs && tableFloor.hasRoomMaps))) ||
    (floorMapsEnabled && (!svgs || (!!svgs && !!tableFloor.floorSvgObj))) ||
    (tablesEnabled && tableFloor.hasRows);

  return (
    <>
      {hasFloorHeader ? (
        <div className="floor-header-container" data-floorid={tableFloor.id}>
          <h2>{tableFloor.name}</h2>
        </div>
      ) : null}

      {svgs && svgDLStarted ? (
        <FloorSvgs
          wifiEnabled={wifiEnabled}
          wiringEnabled={wiringEnabled}
          cameraEnabled={cameraEnabled}
          floorMapsEnabled={floorMapsEnabled}
          roomMapsEnabled={roomMapsEnabled}
          lightingEnabled={lightingEnabled}
          tableFloor={tableFloor}
        />
      ) : null}

      {(tablesEnabled || roomMapsEnabled) &&
      Array.isArray(tableFloor.tableRooms)
        ? tableFloor.tableRooms.map((tableRoom: any) => (
            <TableRoom
              projectId={projectId}
              key={tableRoom.id}
              floorname={tableFloor.name}
              detailsEnabled={detailsEnabled}
              tablesEnabled={tablesEnabled}
              tableDLStarted={tableDLStarted}
              floorMapsEnabled={floorMapsEnabled}
              roomMapsEnabled={roomMapsEnabled}
              gotsvgs={!!svgs}
              tableRoom={tableRoom}
              currency={currency}
              dispatchDownloadStates={dispatchDownloadStates}
              currentRowInEditing={currentRowInEditing}
              setCurrentRowInEditing={setCurrentRowInEditing}
              measurementSystem={measurementSystem}
              quoteUserProperties={quoteUserProperties}
              allManufacturerDiscountForProject={allManufacturerDiscountForProject}
              manufacturerRecommendationForProject={manufacturerRecommendationForProject}
              customItemsForRecommendation={customItemsForRecommendation}
            />
          ))
        : null}
    </>
  );
};
